import { useEffect, useState } from 'react';

import chevronDown from '../../../../../assets/svgs/chevron_down-icon.svg';
import chevronUp from '../../../../../assets/svgs/chevron_up-icon.svg';
import { CustomIcon } from '../../../../../components/widgets/CustomIcon';
import { TooltipComponent } from '../../../../../components/widgets/Tooltip';
import { api } from '../../../../../services/api';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { useNotificationContext } from '../context/NotificationContext';
import { NotificationTableHeaderProps } from '../types/notificationTypes';

const apiNotificacoes = apiSensedia;

// if (process.env.NODE_ENV != 'development') {
//   apiNotificacoes = apiSensedia;
// }

export const NotificationTableHeader = ({
  title,
  subtitle,
  data,
  headersIcons
}: NotificationTableHeaderProps) => {
  const {
    setStatus,
    setCurrentPage,
    setItemsPerPage,
    notificationsFiltered,
    selectAll,
    selectedItems,
    setSelectAll,
    setSelectedItems
  } = useNotificationContext();

  const [statusLabel, setStatusLabel] = useState<string>('Status mensagem');
  const [dropdownIsOpen, setDropdownIsOpen] = useState<boolean>(false);

  const statusOptions = ['Todas', 'Lida', 'Não lida'];

  const toggleDropdownStatus = () => {
    setDropdownIsOpen(!dropdownIsOpen);
  };

  const handleFilterData = async (statusFilter: string) => {
    setStatus(statusFilter);
    setStatusLabel(statusFilter);
    setCurrentPage(1);
    setItemsPerPage(5);
    toggleDropdownStatus();
  };

  const toggleSelectAll = () => {
    const updatedSelectedItems = new Set(selectedItems);

    if (!selectAll) {
      notificationsFiltered.forEach((item) =>
        updatedSelectedItems.add(item.id)
      );
    } else {
      notificationsFiltered.forEach((item) => {
        if (updatedSelectedItems.has(item.id)) {
          updatedSelectedItems.delete(item.id);
        }
      });
    }

    setSelectedItems(updatedSelectedItems);

    setSelectAll(!selectAll);
  };

  return (
    <>
      <div className="tw-pt-5 tw-px-5 tw-mb-4 md:tw-flex tw-justify-between">
        <div>
          <p className="tw-text-[#323232] tw-font-bold tw-text-[1.25rem]">
            {title}
          </p>
          <p>{subtitle}</p>
        </div>
        <div className="tw-relative">
          <button
            disabled={data.length <= 0}
            style={{
              opacity: data.length <= 0 && '0.5',
              cursor: data.length <= 0 && 'not-allowed'
            }}
            className="tw-whitespace-nowrap tw-border tw-flex tw-justify-between tw-items-center tw-border-[#001E64] tw-h-10 tw-rounded-full tw-mt-7 md:tw-mt-0 tw-w-full md:tw-w-52 tw-px-4"
            onClick={() => toggleDropdownStatus()}
          >
            <span>{statusLabel}</span>
            <CustomIcon src={dropdownIsOpen ? chevronDown : chevronUp} />
          </button>
          {dropdownIsOpen && (
            <div className="tw-absolute tw-bg-white tw-shadow-lg tw-w-full tw-rounded-lg tw-z-10">
              {statusOptions.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="tw-text-[#323232] hover:tw-text-[#146CFA] hover:tw-bg-[#E6F7FF] hover:tw-font-bold tw-px-3 tw-py-2 "
                    onClick={() => {
                      handleFilterData(item);
                    }}
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div
          style={{
            opacity: data.length <= 0 && '0.5',
            cursor: data.length <= 0 && 'not-allowed'
          }}
          className="md:tw-hidden tw-border tw-border-[#001E64] tw-font-bold tw-px-11 tw-h-10 tw-rounded-full tw-mt-5 tw-w-full tw-flex tw-gap-4 tw-items-center tw-justify-center"
        >
          <input
            disabled={data.length <= 0}
            checked={selectAll}
            type="checkbox"
            style={{
              cursor: data.length <= 0 && 'not-allowed'
            }}
            className="tw-h-4 tw-w-4"
            onChange={toggleSelectAll}
          />
          <span>Selecionar todos</span>
        </div>
        <div className="tw-hidden md:tw-flex tw-gap-5">
          {headersIcons.map((icon, index) => {
            return (
              <TooltipComponent tooltip={icon.tolltip} key={index}>
                <button
                  disabled={data.length <= 0}
                  style={{
                    opacity: data.length <= 0 && '0.5',
                    cursor: data.length <= 0 && 'not-allowed'
                  }}
                  className="tw-cursor-pointern tw-rounded-full tw-bg-[#d2d2d2a3] hover:tw-bg-[#E9EDF4] tw-transition-opacity tw-flex tw-items-center tw-justify-center tw-p-3"
                  onClick={() => {
                    const idsArray = Array.from(selectedItems);
                    icon.action(idsArray);
                  }}
                >
                  <CustomIcon src={icon.icon} />
                </button>
              </TooltipComponent>
            );
          })}
        </div>
      </div>
      <hr className="tw-mb-5" />
    </>
  );
};
